

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import notificationService from '@/services/notificationService';
import cCard from '@/components/default/Card.vue';
import filesRepository from '@/services/varia/filesRepository';
import { DxTreeList, DxColumn, DxRemoteOperations, DxButton } from 'devextreme-vue/tree-list';
import cPopup from '@/components/default/Popup.vue';
import settings from '@/settings.json';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import FilesTreeList from '@/components/varia/FilesTreeList.vue';

@Component({
  components: {
    cCard,
    DxTreeList,
    DxColumn,
    DxRemoteOperations,
    DxButton,
    DxFileUploader,
    cPopup,
    FilesTreeList,
  },
  computed: {

  },
})
export default class FilesCard extends Vue {
  @Prop({required: true})
  public type!: string;

  @Prop({required: true})
  public id!: string;

  private add(folderId: string = '') {
    (this.$refs.FilesTreeList as FilesTreeList).add();
  }

  private async addFolder() {
    (this.$refs.FilesTreeList as FilesTreeList).addFolder();
  }
}
